import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation  UpdateRegistrationFormMessage($id: Int!, $formId: Int!, $content: String){
    updateRegistrationFormMessage(id: $id, formId: $formId, content: $content) {
      id
      form_id
      content
    }
  }
`;
